module.exports = __webpack_public_path__ + "static/media/About.68133656.svg";